export const findMyInformationDisplayTextEs = {
    dateOfBirthLabel: 'Fecha de nacimiento',
    dateOfBirthPlaceholder: 'MM/DD/AAAA',
    emailLabel: 'Dirección de correo electrónico preferida',
    employeeIdLabel: 'Número de empleado',
    findButton: 'Seguir',
    firstNameLabel: 'Nombre',
    FmiHeading: 'Encontrar mi información',
    FmiText: 'Para garantizar una experiencia segura para nuestros clientes, debe completar una verificación de identidad única completando todos los campos a continuación.',
    invalidSSN: 'Número de seguro social no válido.',
    lastNameLabel: 'Apellido',
    ManageBensHeading: 'Administrar mis beneficiarios',
    postalCodeLabel: 'Código postal',
    ssnLabel: 'Número de seguro social ',
    infoMessage: 'Algo salió mal. Inténtalo de nuevo.',
    noIdFoundErrorMessage: 'No se encontró ninguna identificación. Por favor, verifique su información e inténtelo nuevamente.'
};
